<ng-container *transloco="let t; read: 'project.project-details-table'">
  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!isLoading) {
    <div class="project-details-table__container">
      <div class="project-details-table__top-section-tab-section-wrapper">
        @for (tab of tableTabs; track tab; let i = $index) {
          <ng-container
            *ngTemplateOutlet="tableTab; context: { tabData: tab, tabIndex: i }"
          ></ng-container>
        }
        <div class="project-details-table__top-section-border"></div>
        <ng-template #tableTab let-tabData="tabData" let-tabIndex="tabIndex">
          <div
            (click)="onTabClicked(tabData.id, $event)"
            class="project-details-table__top-section-tab"
            [class.project-details-table__top-section-tab--active]="
              activeTableTabIndex === tabIndex
            "
          >
            @if (tabData.id !== 'all') {
              <xi-icon
                [icon]="icons[tabData.id].icon"
                [color]="icons[tabData.id].color"
                iconSize="small"
              ></xi-icon>
            }
            <span> {{ tabData.label }} ({{ tabData.count ?? '' }}) </span>
          </div>
        </ng-template>
      </div>
      <div class="project-details-table__top-section-actions">
        @if (!projectionBreadcrumbs) {
          <xi-search-box
            [placeholder]="t('search')"
            [outline]="'outline'"
            [ngModel]="filterValue"
            (onChangeOverride)="onFilter($event.detail.searchText)"
            (onCancelClick)="onFilter('')"
          ></xi-search-box>
        }
        @if (projectionBreadcrumbs) {
          <div class="project-details-table__breadcrumb-wrapper">
            @for (crumb of projectionBreadcrumbs; track i; let i = $index) {
              <span
                (click)="crumb.action && crumb.action()"
                class="project-details-table__breadcrumb"
              >
                {{ crumb.label }}
              </span>
              @if (i < projectionBreadcrumbs.length - 1) {
                <span class="project-details-table__breadcrumb-separator"> &gt; </span>
              }
            }
          </div>
        }
        @if (!isReadOnly) {
          @if (!subTableItem) {
            <ng-container *ngTemplateOutlet="topLevelTableActions"></ng-container>
          } @else {
            @if (subTableItem.type === 'collection') {
              <ng-container *ngTemplateOutlet="analysisTableActions"></ng-container>
            } @else {
              <div class="project-details-table__sub-table-actions">
                @if (!isReadOnly) {
                  <xi-icon-button
                    [tooltip]="
                      subTableItem.group.collectionQuery
                        ? { text: t('delete-group-disabled') }
                        : { text: t('delete') }
                    "
                    icon="trash"
                    [disabled]="!!subTableItem.group.collectionQuery"
                    (onClick)="groupActions.showAnalysisGroupDeleteDialog(subTableItem.group)"
                  ></xi-icon-button>
                  <xi-icon-button
                    [tooltip]="{ text: t('rename') }"
                    icon="edit"
                    (onClick)="groupActions.onShowRenameAnalysisGroupDialog(subTableItem.group)"
                  ></xi-icon-button>
                  <xi-default-button
                    [text]="t('edit-analysis-group')"
                    [disabled]="!!subTableItem.group.collectionQuery"
                    [tooltip]="
                      subTableItem.group.collectionQuery
                        ? { text: t('edit-group-disabled') }
                        : undefined
                    "
                    [tooltipDisplayOnDisabled]="true"
                    (onClick)="groupActions.onShowNewAnalysisGroupDialog(subTableItem.group)"
                  ></xi-default-button>
                }
              </div>
            }
          }
        }
      </div>
      @if (subTableItem?.type === 'collection') {
        <div class="project-details-table__top-section-total-docs-row">
          <div class="kxi-text-small kxi-text-600">
            {{ t('total-docs') }}:
            <span class="kix-text-400">{{ subTableItem | tableDocCount | number }}</span>
          </div>
          <div class="project-details-table__top-section-divider"></div>
          @if (!isReadOnly) {
            <div
              [matTooltip]="subTableItem.displayData.autoAnalysisButtonData.autoAnalysisTooltip"
              matTooltipClass="tooltip-newline"
            >
              <label class="kxi-text-small kxi-text-600" for="auto-analyze-toggle"
                >{{ t('auto-analysis') }}:</label
              >
              <xi-toggle-switch
                id="auto-analyze-toggle"
                [leftText]="t('off')"
                [rightText]="t('on')"
                [isToggled]="subTableItem.collection.data.isAutoAnalyze"
                [disabled]="
                  !!subTableItem.displayData.autoAnalysisButtonData.autoAnalysisTooltip ||
                  subTableItem.collection.data.locked ||
                  (!subTableItem.collection.data.isAutoAnalyze &&
                    !subTableItem.collection.canCreateAnalysis)
                "
                (onToggle)="onAutoAnalyzeToggle($event, subTableItem)"
              ></xi-toggle-switch>
            </div>
          }
        </div>
      }
      <div
        [ngClass]="
          subTableItem?.type === 'collection'
            ? 'project-details-table__table-wrapper--subtable'
            : 'project-details-table__table-wrapper'
        "
      >
        <table
          #projectDetailsTable
          mat-table
          multiTemplateDataRows
          [dataSource]="projectItemsDatasource"
          matSort
          matSortDisableClear
          [matSortActive]="sort.active"
          [matSortDirection]="sort.direction"
          (matSortChange)="onTableSortChange($event)"
        >
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>
              <div>
                <span>{{ t('type') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item" [attr.rowspan]="itemHasLabels(0, item) ? 2 : 1">
              <div
                class="project-details-table__cell-wrapper project-details-table__cell-wrapper--first"
              >
                <div class="project-details-table__type-icon table-group">
                  <xi-icon
                    [icon]="icons[item.isSocial ? 'socialCollection' : item.type].icon"
                    [color]="icons[item.isSocial ? 'socialCollection' : item.type].color"
                    [tooltipProps]="{
                      text:
                        icons[item.isSocial ? 'socialCollection' : item.type].tooltip | titlecase,
                      direction: 12,
                    }"
                    iconSize="large"
                  ></xi-icon>
                  @if (item?.group?.collectionQuery) {
                    <xi-icon
                      [icon]="icons['dynamicGroup'].icon"
                      iconSize="small"
                      class="dynamic-group"
                      [color]="icons['dynamicGroup'].color"
                      [tooltipProps]="{
                        text: icons['dynamicGroup'].tooltip | titlecase,
                        direction: 3,
                      }"
                    ></xi-icon>
                  }
                  <div
                    class="project-details-table__warning-icon"
                    [class.project-details-table__warning-icon--selected]="
                      item.id === this.selectedItem?.id
                    "
                  >
                    @if (item.type === 'collection') {
                      @if (item.collection.documentCount === 0) {
                        <xi-icon
                          icon="warning_filled"
                          iconSize="small"
                          color="error"
                          [tooltipProps]="{
                            text: t('coll-no-docs'),
                            direction: 3,
                          }"
                        ></xi-icon>
                      }
                      @if (item.collection.documentsNeedAnalyze) {
                        <xi-icon
                          icon="warning"
                          iconSize="small"
                          color="warning"
                          [tooltipProps]="{
                            text: t('docs-not-analyzed'),
                            direction: 3,
                          }"
                        ></xi-icon>
                      }
                      @if (item.collection.analyzeState === 'ERROR') {
                        <xi-icon
                          icon="warning_filled"
                          iconSize="small"
                          color="error"
                          [tooltipProps]="{
                            text: t('error-analysis'),
                          }"
                        ></xi-icon>
                      }
                    }
                    @if (item.displayData.isLocked) {
                      <xi-icon
                        icon="password_filled"
                        iconSize="small"
                        color="orca"
                        [tooltipProps]="{
                          text: t('item-locked'),
                          direction: 3,
                        }"
                      ></xi-icon>
                    }
                    @if (item.type === 'analysis') {
                      @if (item.displayData.isDriverAnalysis) {
                        <xi-icon icon="impact_analysis" iconSize="small" color="success"></xi-icon>
                      }
                      @if (item.displayData.isAutoAnalysis) {
                        <xi-icon icon="convert" iconSize="small" color="success"></xi-icon>
                      }
                    }
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <div>
                <span>{{ t('name') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item">
              <div class="project-details-table__cell-wrapper">
                <div class="project-details-table__item_name">
                  <span *appMiddleEllipsize="item.name"></span>
                  @if (item.type === 'analysis' && item.analysis?.primary) {
                    <span class="primary-icon">
                      <xi-icon
                        icon="star_filled"
                        iconSize="small"
                        [tooltipProps]="{
                          text: t('primary'),
                          direction: 12,
                        }"
                      >
                      </xi-icon>
                    </span>
                  }
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="collection">
            <th mat-header-cell *matHeaderCellDef>
              <div>
                <span>{{ t('collection') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item">
              <div class="project-details-table__cell-wrapper">
                <span class="project-details-table__item_name">
                  <span *appMiddleEllipsize="item.displayData.collectionName"></span>
                </span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="config">
            <th mat-header-cell *matHeaderCellDef>
              <div>
                <span>{{ t('configuration') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item">
              <div class="project-details-table__cell-wrapper">
                <span class="project-details-table__item_name">
                  <span *appMiddleEllipsize="item.displayData.configName"></span>
                </span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef>
              <div>
                <span>{{
                  subTableItem?.type === 'collection' ? t('analyzed') : t('details')
                }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item">
              <div class="project-details-table__cell-wrapper">
                <!--group details-->
                @if (item.type === 'group') {
                  <ng-container *ngTemplateOutlet="tItemCounts; context: { $implicit: item }">
                  </ng-container>
                }
                <!--collection details-->
                @if (item.type === 'collection') {
                  <!-- if Active analysis -->
                  @if (getCollectionAnalyzeState(item); as analyzeState) {
                    <ng-container
                      *ngTemplateOutlet="
                        tAnalyzeState;
                        context: {
                          collectionItem: item.collection,
                          analyzeState: analyzeState,
                        }
                      "
                    ></ng-container>
                  } @else {
                    @if (getIndexState(item); as indexState) {
                      <ng-container
                        *ngTemplateOutlet="
                          tIndexState;
                          context: {
                            indexState: indexState,
                          }
                        "
                      ></ng-container>
                    } @else {
                      @if (!item.collection.shouldShowCompleteUpload) {
                        @if (item.collection.documentCount || isReadOnly) {
                          <span>{{ item | tableDocCount | number }} {{ t('docs') }}</span>
                        } @else {
                          <xi-default-button
                            class="project-details-table__warning-link-button"
                            [text]="t('no-docs')"
                            fill="link"
                            color="error"
                            [tooltip]="{ text: t('upload-docs') }"
                            [hasAnimation]="false"
                            (onClick)="collectionActions.onShowNewCollectionDialog(item.collection)"
                          ></xi-default-button>
                        }
                        @if (item.displayData.analysisCount || isReadOnly) {
                          <ng-container
                            *ngTemplateOutlet="tAnalysisCounts; context: { $implicit: item }"
                          ></ng-container>
                        } @else {
                          @if (item.collection.shouldShowCreateFirstAnalysis) {
                            <span> | </span>
                            <xi-default-button
                              class="project-details-table__warning-link-button"
                              fill="link"
                              [text]="t('no-analyses')"
                              color="warning"
                              [tooltip]="{ text: t('analyze-docs') }"
                              [hasAnimation]="false"
                              [disabled]="!item.collection.canCreateAnalysis"
                              (onClick)="
                                collectionActions.showNewAnalysisDialog(
                                  item.collection,
                                  undefined,
                                  $event
                                )
                              "
                            ></xi-default-button>
                          }
                        }
                      }
                      @if (item.collection.shouldShowCompleteUpload && !isReadOnly) {
                        <xi-default-button
                          [text]="t('complete-upload')"
                          fill="link"
                          [hasAnimation]="false"
                          (onClick)="collectionActions.completeUpload(item.collection, $event)"
                        ></xi-default-button>
                      }
                    }
                  }
                  <!-- if active indexing -->
                  <!-- if not active analysis -->
                }
                @if (item.type === 'analysis') {
                  <div class="project-details-table__analysis-details">
                    <!-- if Active analysis -->
                    @if (getAnalyzeState(item.analysis); as analyzeState) {
                      <ng-container
                        *ngTemplateOutlet="
                          tAnalyzeState;
                          context: {
                            collectionItem: { activeAnalysis: item.analysis },
                            analyzeState: analyzeState,
                          }
                        "
                      ></ng-container>
                    } @else {
                      <ng-container *ngTemplateOutlet="tItemCounts; context: { $implicit: item }">
                      </ng-container>
                    }
                  </div>
                }
                @if (item.type === 'dashboard') {
                  <ng-container *ngTemplateOutlet="emptyField"></ng-container>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="modified">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <div>
                <span>{{ t('modified') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let item">
              <div class="project-details-table__cell-wrapper">{{ item.modified | lexDate }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item" [attr.rowspan]="itemHasLabels(0, item) ? 2 : 1">
              <div
                class="project-details-table__cell-wrapper project-details-table__cell-wrapper--last"
              >
                @if (!hideKabobMenu(item)) {
                  <div [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{ item: item }">
                    <xi-icon-button icon="kabob"></xi-icon-button>
                  </div>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="labels">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item" [attr.colspan]="labelsColumnSpan">
              <div class="project-details-table__cell-wrapper">
                <app-project-details-table-labels
                  [labels]="item.labels"
                  [projectItemType]="item.type"
                ></app-project-details-table-labels>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="projectItemsColumns; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: projectItemsColumns; let i = index"
            [class.project-details-table__row--selected]="row.id === this.selectedItem?.id"
            [class.project-details-table__row--deleting]="isItemDeleting(row)"
            [class.project-details-table__row--analyzing]="isItemAnalyzing(row)"
            (click)="itemSelected(row, i, false)"
            (dblclick)="onOpenItem(row)"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['labels']; when: itemHasLabels; let i = index"
            class="project-details-table__labels-row"
            [class.project-details-table__row--selected]="row.id === this.selectedItem?.id"
            [class.project-details-table__row--deleting]="isItemDeleting(row)"
            [class.project-details-table__row--analyzing]="isItemAnalyzing(row)"
            (click)="itemSelected(row, i, false)"
            (dblclick)="onOpenItem(row)"
          ></tr>
          <!-- Table empty states -->
          <tr *matNoDataRow>
            <td [attr.colspan]="projectItemsColumns.length">
              <div class="project-details-table__no-results">
                @if (tableItems.length === 0) {
                  <!-- Initial project details page empty state -->
                  @if (activeTableTabIndex === 0 && !isExecutive) {
                    <div class="project-details-table__new-project-svg">
                      <xi-svg svg="graph_mobile_web"></xi-svg>
                    </div>
                    <h2 class="kxi-text-xlarge kxi-text-600">{{ t('welcome-to-project') }}</h2>
                    @if (!isReadOnly) {
                      <p class="kxi-text-medium">
                        {{ t('create-first-collection') }}
                      </p>
                      <xi-default-button
                        [text]="t('create-collection')"
                        iconLeft="add_circle"
                        (onClick)="collectionActions.onShowNewCollectionDialog()"
                      ></xi-default-button>
                    }
                  } @else {
                    <div class="project-details-table__no-data-svg">
                      <xi-svg svg="none"></xi-svg>
                    </div>
                    <p class="kxi-text-large kxi-text-600">
                      {{ tableTabs[activeTableTabIndex].emptyText }}
                    </p>
                  }
                } @else {
                  @if (projectItemsDatasource.data.length === 0) {
                    <!-- collection/group sub-table empty state -->
                    @if (subTableItem) {
                      <div class="project-details-table__no-data-svg">
                        <xi-svg
                          [svg]="
                            subTableItem.type === 'collection'
                              ? 'browser_refresh'
                              : 'graph_progress_search'
                          "
                        ></xi-svg>
                      </div>
                      <p class="kxi-text-large kxi-text-600 project-details-table__no-data-title">
                        {{
                          subTableItem.type === 'collection'
                            ? t('welcome-to-collection')
                            : t('welcome-to-analysis-group')
                        }}
                      </p>
                      <p class="kxi-text-small">
                        {{
                          subTableItem.type === 'collection'
                            ? t('welcome-to-collection-subtitle')
                            : t('welcome-to-analysis-group-subtitle')
                        }}
                      </p>
                    } @else {
                      <div class="project-details-table__no-data-svg">
                        <xi-svg svg="none"></xi-svg>
                      </div>
                      <p class="kxi-text-large kxi-text-600">
                        {{ tableTabs[activeTableTabIndex].emptyText }}
                      </p>
                    }
                  } @else {
                    <h2 class="kxi-text-xlarge kxi-text-600">{{ t('no-results') }}</h2>
                  }
                }
              </div>
              <!-- No results state (for filtering) -->
              <!-- Empty state for top-level table tabs -->
            </td>
          </tr>
        </table>
      </div>
    </div>
  }

  <mat-menu #actionMenu class="project-collections-menu menu-with-xi-icons">
    <ng-template matMenuContent let-item="item">
      <!-- Dashboard Menu Actions -->
      @if (item.type === 'dashboard') {
        <button mat-menu-item (click)="onOpenItem(item, $event)">
          <xi-icon color="orca" icon="external_link"></xi-icon>
          <div>{{ t('open') }}</div>
        </button>
        <button
          mat-menu-item
          (click)="dashboardActions.onCopyDashboardIdToClipboard(item.dashboard)"
        >
          <xi-icon icon="copy_filled"></xi-icon>
          <div>{{ t('copy-id-to-clipboard') }}</div>
        </button>
        @if (!isReadOnly) {
          <button mat-menu-item (click)="dashboardActions.cloneDashboard(item.dashboard)">
            <xi-icon color="orca" icon="copy"></xi-icon>
            <div>{{ t('clone') }}</div>
          </button>
        }
        @if (!isReadOnly) {
          <button
            mat-menu-item
            (click)="dashboardActions.showDeleteDashboardDialog(item.dashboard)"
          >
            <xi-icon color="orca" icon="trash"></xi-icon>
            <div>{{ t('delete') }}</div>
          </button>
        }
      }

      <!-- Group Menu Actions -->
      @if (item.type === 'group') {
        <button mat-menu-item (click)="onOpenItem(item, $event)">
          <xi-icon color="orca" icon="external_link"></xi-icon>
          <div>{{ t('open') }}</div>
        </button>
        <button
          mat-menu-item
          [disabled]="!!item?.group?.collectionQuery"
          [matTooltip]="item?.group?.collectionQuery ? t('clone-group-disabled') : ''"
          matTooltipClass="tooltip-newline"
          (click)="this.groupActions.cloneAnalysisGroup(item.group)"
        >
          <xi-icon color="orca" icon="copy"></xi-icon>
          <div>{{ t('clone-analysis-group') }}</div>
        </button>
        <button mat-menu-item (click)="groupActions.onCopyAnalysisGroupIdToClipboard(item.group)">
          <xi-icon icon="copy_filled"></xi-icon>
          <div>{{ t('copy-id-to-clipboard') }}</div>
        </button>
        <button
          mat-menu-item
          [disabled]="!!item.group.collectionQuery"
          [matTooltip]="item.group.collectionQuery ? t('delete-group-disabled') : ''"
          matTooltipClass="tooltip-newline"
          (click)="groupActions.showAnalysisGroupDeleteDialog(item.group)"
        >
          <xi-icon color="orca" icon="trash"></xi-icon>
          <div>{{ t('delete-analysis-group') }}</div>
        </button>
      }

      <!-- Collection Menu Actions -->
      @if (item.type === 'collection' && !item.isSocial) {
        @if (canOpenCollection(item?.collection)) {
          <button mat-menu-item (click)="onOpenItem(item, $event)">
            <xi-icon color="orca" icon="external_link"></xi-icon>
            <div>{{ t('open') }}</div>
          </button>
        }
        @if (!isReadOnly) {
          <div>
            <button
              mat-menu-item
              (click)="collectionActions.onShowNewCollectionDialog(item.collection)"
              [disabled]="disableUploadDocuments(item.collection.data)"
              [matTooltip]="
                disableUploadDocuments(item.collection.data)
                  ? item.collection.data.locked
                    ? t('collection-locked')
                    : t('upload-collection-disabled')
                  : ''
              "
              matTooltipClass="tooltip-newline"
            >
              <xi-icon icon="upload"></xi-icon>
              <div>{{ t('upload-docs') }}</div>
            </button>
          </div>
        }
        @if (!isReadOnly) {
          <div
            [matTooltip]="item.displayData.autoAnalysisButtonData.autoAnalysisTooltip"
            matTooltipClass="tooltip-newline"
            matTooltipPosition="left"
          >
            <button
              mat-menu-item
              [disabled]="
                !!item.displayData.autoAnalysisButtonData.autoAnalysisTooltip ||
                item.collection.data.locked
              "
              (click)="collectionActions.onAutoAnalysisButtonClick(item)"
            >
              <xi-icon
                [color]="
                  !!item.displayData.autoAnalysisButtonData.autoAnalysisTooltip
                    ? 'disabled'
                    : 'orca'
                "
                icon="impact_analysis"
              ></xi-icon>
              <div>{{ item.displayData.autoAnalysisButtonData.autoAnalysisButtonText }}</div>
            </button>
          </div>
        }
        @if (!isReadOnly) {
          <div>
            <button
              mat-menu-item
              [disabled]="item.collection.data.locked"
              (click)="collectionActions.onOpenCollectionSettings(item.collection.data, project)"
            >
              <xi-icon icon="settings"></xi-icon>
              <div>{{ t('edit-collection-settings') }}</div>
            </button>
          </div>
        }
        @if (!isReadOnly) {
          <div>
            <button
              mat-menu-item
              [disabled]="item.collection.data.locked"
              (click)="collectionActions.onOpenCalculatedFieldConfigModal(item.collection.data)"
            >
              <xi-icon icon="distinct_count"></xi-icon>
              <div>{{ t('configure-calculated-fields') }}</div>
            </button>
          </div>
        }
        @if (!isReadOnly && item.displayData.hasLLMFeature) {
          <div>
            <button
              class="project-details-table__multi-line-button"
              mat-menu-item
              [disabled]="item.collection.data.locked"
              (click)="collectionActions.onShowSceneSelectDialog(item.collection)"
            >
              <xi-icon icon="app_announcements"></xi-icon>
              <div [innerHTML]="t('configure-smart-summary')"></div>
            </button>
          </div>
        }
        @if (!isReadOnly) {
          <button
            mat-menu-item
            (click)="collectionActions.onToggleLockCollection(item.collection.data)"
          >
            <xi-icon [icon]="item.collection.data.locked ? 'disable' : 'enable'"></xi-icon>
            <div>
              {{ item.collection.data.locked ? t('unlock-collection') : t('lock-collection') }}
            </div>
          </button>
        }
        <button
          mat-menu-item
          [disabled]="!item.collection.uploads?.length"
          [matTooltip]="
            item.collection.uploads?.length ? null : t('collection-information-unavailable')
          "
          matTooltipClass="tooltip-newline"
          (click)="collectionActions.showUploadInfoDialog(item.collection)"
        >
          <xi-icon icon="info"></xi-icon>
          <div>{{ t('collection-information') }}</div>
        </button>
        <div>
          <button
            mat-menu-item
            (click)="collectionActions.onCopyCollectionIdToClipboard(item.collection)"
          >
            <xi-icon icon="copy_filled"></xi-icon>
            <div>{{ t('copy-id-to-clipboard') }}</div>
          </button>
        </div>
        @if (!isReadOnly) {
          <div
            [matTooltip]="item.collection.data.locked ? t('collection-locked') : ''"
            matTooltipClass="tooltip-newline"
          >
            <button
              mat-menu-item
              [disabled]="!item.collection.canDeleteCollection || item.collection.data.locked"
              (click)="collectionActions.onShowCollectionDeleteDialog(item.collection)"
            >
              <xi-icon
                icon="trash"
                [color]="!item.collection.canDeleteCollection ? 'disabled' : 'orca'"
              ></xi-icon>
              <div>{{ t('delete-collection') }}</div>
            </button>
          </div>
        }
      }

      <!-- Social Collection Menu Actions -->
      @if (item.type === 'collection' && item.isSocial) {
        @if (item.collection.uploads?.length) {
          <button mat-menu-item (click)="collectionActions.showUploadInfoDialog(item.collection)">
            <xi-icon icon="info"></xi-icon>
            <div>{{ t('collection-information') }}</div>
          </button>
        }
      }

      <!-- Analysis Menu Actions -->
      @if (item.type === 'analysis' && subTableItem.type !== 'group') {
        @if (!item.displayData.isDriverAnalysis) {
          @if (item.analysis.status === 'IDLE' && !this.isReadOnly) {
            <button
              [disabled]="subTableItem.collection.data.locked"
              mat-menu-item
              (click)="collectionActions.onAnalysisAction('OPEN_NEW_ANALYSIS_DIALOG', item)"
            >
              <xi-icon color="orca" icon="edit"></xi-icon>
              <div>{{ t('rename') }}</div>
            </button>
          }
          @if (item.analysis.status === 'IDLE') {
            <button
              mat-menu-item
              [matMenuTriggerFor]="
                !subTableItem.collection.data.locked ? analysisExcelDownloadMenuTrigger : null
              "
              [matMenuTriggerData]="{ selectedAnalysis: item.analysis }"
              [disabled]="subTableItem.collection.data.locked"
            >
              <xi-icon color="orca" icon="document_ext_excel"></xi-icon>
              <div>{{ t('download-excel-report') }}</div>
            </button>
          }
          @if (showDeleteAnalysis(item)) {
            <button
              mat-menu-item
              [disabled]="reAnalyzeDisabled"
              [matTooltip]="
                subTableItem.collection.data.isAutoAnalyze
                  ? t('re-analyze-not-allowed-for-auto-analysis')
                  : subTableItem.collection.activeAnalysis
                    ? t('re-analyze-not-allowed-when-another-analysis-is-running')
                    : ''
              "
              (click)="collectionActions.onAnalysisAction('OPEN_RE_ANALYSIS_DIALOG', item)"
            >
              <xi-icon color="orca" icon="copy"></xi-icon>
              <div>{{ t('re-analyze') }}</div>
            </button>
          }
          @if (item.analysis.isReAnalyze && !isReadOnly) {
            <button
              [disabled]="subTableItem.collection.data.locked"
              mat-menu-item
              (click)="collectionActions.onAnalysisAction('OPEN_STOP_RE_ANALYSIS_DIALOG', item)"
            >
              <xi-icon color="orca" icon="cancel"></xi-icon>
              <div>{{ t('stop-re-analysis') }}</div>
            </button>
          }
          @if (showEmbeddingStatus(item)) {
            <button
              mat-menu-item
              [disabled]="!!item.analysis | isAnalysisDisabled"
              (click)="collectionActions.onAnalysisAction('CHECK_EMBEDDINGS', item)"
            >
              <xi-icon color="orca" icon="copy"></xi-icon>
              <div>{{ t('check-embeddings-status') }}</div>
            </button>
          }
          <button
            mat-menu-item
            (click)="collectionActions.onAnalysisAction('COPY_ID_TO_CLIPBOARD', item)"
          >
            <xi-icon color="orca" icon="copy_filled"></xi-icon>
            <div>{{ t('copy-id-to-clipboard') }}</div>
          </button>
          @if (!isReadOnly) {
            <button
              [disabled]="!!item.analysis.primary || projectItemsDatasource.data.length === 1"
              mat-menu-item
              (click)="makePrimaryAnalysis(item.analysis)"
            >
              <xi-icon color="orca" icon="star"></xi-icon>
              <div>{{ t('make-primary') }}</div>
            </button>
          }
          @if (showDeleteAnalysis(item)) {
            <button
              mat-menu-item
              [disabled]="
                subTableItem.collection.data.isAutoAnalyze || subTableItem.collection.data.locked
              "
              (click)="collectionActions.onAnalysisAction('OPEN_DELETE_ANALYSIS_DIALOG', item)"
            >
              <xi-icon color="orca" icon="trash"></xi-icon>
              <div>{{ t('delete-analysis') }}</div>
            </button>
          }
        }
        @if (!isReadOnly) {
          <div>
            @if (item.displayData.isDriverAnalysis) {
              <button
                mat-menu-item
                (click)="
                  collectionActions.onAnalysisAction('OPEN_DELETE_DRIVER_ANALYSIS_DIALOG', item)
                "
              >
                <xi-icon color="orca" icon="trash"></xi-icon>
                <div>{{ t('delete-driver-analysis') }}</div>
              </button>
            }
          </div>
        }
      }

      <!-- Group Analysis Menu Actions -->
      @if (item.type === 'analysis' && subTableItem.type === 'group') {
        <button
          mat-menu-item
          (click)="collectionActions.onAnalysisAction('COPY_ID_TO_CLIPBOARD', item)"
        >
          <xi-icon icon="copy_filled"></xi-icon>
          <div>{{ t('copy-id-to-clipboard') }}</div>
        </button>
      }
    </ng-template>
  </mat-menu>

  <mat-menu #analysisExcelDownloadMenuTrigger="matMenu">
    <ng-template matMenuContent let-selectedAnalysis="selectedAnalysis">
      <div mat-menu-item class="mat-menu-header" disabled>{{ t('create-report') }}</div>

      <button
        mat-menu-item
        (click)="
          collectionActions.downloadAnalysisExcelReport(
            selectedAnalysis,
            'DOCUMENT_DETAILS_REPORT',
            'Docs'
          )
        "
      >
        <div>{{ t('document-details') }}</div>
      </button>

      <div
        [matTooltip]="
          !selectedAnalysis?.topicTypes.includes('query')
            ? t('selected-analysis-no-query-topics')
            : undefined
        "
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'QUERY_DETAILS_REPORT',
              'Query Topics'
            )
          "
          [disabled]="!selectedAnalysis?.topicTypes.includes('query')"
        >
          <div>{{ t('query-topics') }}</div>
        </button>
      </div>

      <div
        [matTooltip]="
          !selectedAnalysis?.topicTypes.includes('concept')
            ? t('selected-analysis-no-concept-topics')
            : undefined
        "
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'CONCEPT_DETAILS_REPORT',
              'Concept Topics'
            )
          "
          [disabled]="!selectedAnalysis?.topicTypes.includes('concept')"
        >
          <div>{{ t('concept-topics') }}</div>
        </button>
      </div>

      <div
        [matTooltip]="!selectedAnalysis?.hasThemes ? t('selected-analysis-no-themes') : undefined"
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'THEME_DETAILS_REPORT',
              'Themes'
            )
          "
          [disabled]="!selectedAnalysis?.hasThemes"
        >
          <div>{{ t('themes') }}</div>
        </button>
      </div>

      <div
        [matTooltip]="
          !selectedAnalysis?.hasEntities ? t('selected-analysis-no-entities') : undefined
        "
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'ENTITY_DETAILS_REPORT',
              'Entities'
            )
          "
          [disabled]="!selectedAnalysis?.hasEntities"
        >
          <div>{{ t('entities') }}</div>
        </button>
      </div>

      <div
        [matTooltip]="
          !selectedAnalysis?.hasEntities ? t('selected-analysis-no-entities') : undefined
        "
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'ENTITY_THEME_DETAILS_REPORT',
              'Entity Themes'
            )
          "
          [disabled]="!selectedAnalysis?.hasEntities"
        >
          <div>{{ t('entity-themes') }}</div>
        </button>
      </div>

      <div
        [matTooltip]="
          !selectedAnalysis?.hasTaxonomy ? t('selected-analysis-no-taxonomy') : undefined
        "
      >
        <button
          mat-menu-item
          (click)="
            collectionActions.downloadAnalysisExcelReport(
              selectedAnalysis,
              'TAXONOMY_DETAILS_REPORT',
              'Taxonomy'
            )
          "
          [disabled]="!selectedAnalysis?.hasTaxonomy"
        >
          <div>{{ t('taxonomy') }}</div>
        </button>
      </div>
    </ng-template>
  </mat-menu>

  <!-- collection or group or analysis-->
  <ng-template #tItemCounts let-item>
    @if (item.displayData.docCount || item.displayData.analysisCount) {
      @if (item.displayData.docCount) {
        <span>{{ item | tableDocCount | number }} {{ t('docs') }} </span>
      }
      @if (item.displayData.analysisCount) {
        <ng-container
          *ngTemplateOutlet="tAnalysisCounts; context: { $implicit: item }"
        ></ng-container>
      }
    } @else {
      <span>&#8211;</span>
    }
  </ng-template>

  <ng-template #tAnalysisCounts let-item>
    @if (!item.collection || item.collection.analyzeState !== 'ERROR') {
      <span> | {{ item.displayData.analysisCount | number }} {{ t('analyses') }}</span>
    }
    @if (item.collection && item.collection.analyzeState === 'ERROR') {
      <span> | </span>
      <xi-default-button
        [text]="t('number-analyses', { count: item.displayData.analysisCount })"
        fill="link"
        color="error"
        [hasAnimation]="false"
        (onClick)="onOpenItem(item, $event)"
        class="project-details-table__warning-link-button"
      ></xi-default-button>
    }
  </ng-template>

  <!-- collection and analysis -->
  <ng-template #tAnalyzeState let-collectionItem="collectionItem" let-analyzeState="analyzeState">
    <!-- analyze state -->
    @if (analyzeState === 'ERROR') {
      <xi-icon
        icon="warning_filled"
        iconSize="normal"
        color="warning"
        [tooltipProps]="{
          text: t('error-analysis') + ': ' + collectionItem.activeAnalysis.statusText,
        }"
      ></xi-icon>
    }
    @if (analyzeState === 'STARTED') {
      <div class="project-details-table__analyzing">
        <div class="project-details-table__loader-wrapper">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
        <div class="project-details-table__analyzing-copy">
          <div
            #analysisStatusTooltip="matTooltip"
            #analysisStatusLine
            class="project-details-table__analysis-line"
            [matTooltip]="
              t('analyzing-progress', {
                progress:
                  (Math.min(collectionItem.activeAnalysis?.progress * 100, 99) | number: '1.0-0'),
              })
            "
            [matTooltipDisabled]="false"
          >
            {{ t('analyzing') }} ({{
              Math.min(collectionItem.activeAnalysis?.progress * 100, 99) | number: '1.0-0'
            }}%)
          </div>
          @if (
            collectionItem.activeAnalysis?.status === 'OPEN' ||
            collectionItem.activeAnalysis?.status === 'QUEUED'
          ) {
            <div
              #analysisDocumentsTooltip="matTooltip"
              #analysisDocumentsLine
              class="project-details-table__analysis-subheader project-details-table__analysis-line kxi-text-small"
              [matTooltip]="
                t('analyzing-div', {
                  processedCount: (collectionItem.activeAnalysis?.processedCount | number),
                  totalCount: (collectionItem.activeAnalysis?.documentCount | number),
                })
              "
              [matTooltipDisabled]="false"
            >
              {{
                t('analyzing-div', {
                  processedCount: (collectionItem.activeAnalysis?.processedCount | number),
                  totalCount: (collectionItem.activeAnalysis?.documentCount | number),
                })
              }}
            </div>
          }
        </div>
      </div>
    }
    @if (analyzeState === 'DELETED') {
      <div class="project-details-table__deleting">
        <div class="project-details-table__loader-wrapper">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
        <div>
          {{ t('deleting') }}
        </div>
      </div>
    }
  </ng-template>

  <!-- INDEX STATE -->
  <ng-template #tIndexState let-indexState="indexState">
    @if (indexState === 'STARTED' || indexState === 'MAPPED') {
      <div class="project-details-table__analyzing">
        <div class="project-details-table__loader-wrapper">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
        <div>{{ t('indexing') }}</div>
      </div>
    } @else {
      @if (indexState === 'ERROR') {
        <xi-icon
          icon="warning_filled"
          iconSize="normal"
          color="warning"
          [tooltipProps]="{
            text: t('error-indexing'),
          }"
        ></xi-icon>
      } @else {
        <span>&#8211;</span>
      }
    }
  </ng-template>

  @if (showImportDialog) {
    <app-import-dialog
      [isShowing]="showImportDialog"
      [title]="t('import-dashboard')"
      [description]="t('import-dashboard-from-valid-file')"
      [itemValidator]="importValidator"
      (modalClosed)="onCloseImportDashboardDialog($event)"
    >
    </app-import-dialog>
  }

  <app-project-dashboard-actions
    #dashboardActions
    [project]="project"
  ></app-project-dashboard-actions>

  <app-project-group-actions
    #groupActions
    [project]="project"
    [configurations]="configurations"
    [projectCollections]="projectCollections"
  ></app-project-group-actions>

  <app-project-collection-actions
    #collectionActions
    [project]="project"
    [projectCollections]="projectCollections"
    [configurations]="configurations"
    [groupConfigurations]="groupConfigurations"
  ></app-project-collection-actions>

  <!-- top of table actions -->
  <ng-template #topLevelTableActions>
    @if (activeTableTabIndex === 0) {
      <div class="project-details-table__create_item_wrapper">
        <!-- if 'all' tab -->
        <div class="project-details-table__create-placeholder kxi-text-normal">
          {{ t('create') }}
        </div>
        <xi-dropdown
          [data]="createItemDropdown"
          select="none"
          [placeholder]="t('create')"
          contrast="high"
          [stretch]="true"
          (onValueChange)="onCreateItem($event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    } @else {
      <div class="project-details-table__top-actions-row">
        @if (
          tableTabs[activeTableTabIndex].id === 'dashboard' &&
          hasSpotlightAssistantFeature &&
          !isExecutive
        ) {
          <div class="project-details-table__vibe-it-up-wrapper">
            <div class="project-details-table__vibe-it-up-label kxi-text-normal">
              <xi-icon icon="rocket" size="16"></xi-icon>
              {{ t('vibe-it-up-button') }}
            </div>
            <div [matTooltip]="vibeItUpSubtitle">
              <xi-dropdown
                [data]="vibeItUpDropdown"
                select="none"
                [placeholder]="t('vibe-it-up-button')"
                [stretch]="true"
                [disabled]="vibeItUpDisabled"
                (onValueChange)="onVibeItUpDropdownSelect($event.detail.selected.id)"
              ></xi-dropdown>
            </div>
          </div>
        }
        <div [matTooltip]="createItemDropdown[activeTableTabIndex - 1].subtitle">
          <xi-default-button
            [text]="tableTabs[activeTableTabIndex].buttonLabel"
            [disabled]="!!createItemDropdown[activeTableTabIndex - 1].disabled"
            buttonSize="small"
            (onClick)="onCreateItem(tableTabs[activeTableTabIndex].id)"
          ></xi-default-button>
        </div>
      </div>
    }
    <!-- If collection, dash, group directory -->
  </ng-template>

  <!-- analysis table top actions -->
  <ng-template #analysisTableActions>
    <div class="project-details-table__sub-table-actions">
      @if (!isReadOnly) {
        <xi-icon-button
          [tooltip]="{ text: t('delete') }"
          [disabled]="
            subTableItem.collection.data.locked || !subTableItem.collection.canDeleteCollection
          "
          icon="trash"
          (onClick)="collectionActions.onShowCollectionDeleteDialog(subTableItem.collection)"
        ></xi-icon-button>
        <xi-icon-button
          [tooltip]="{
            text: subTableItem.collection.data.locked
              ? t('unlock-collection')
              : t('lock-collection'),
          }"
          [icon]="subTableItem.collection.data.locked ? 'password_open' : 'password'"
          (onClick)="collectionActions.onToggleLockCollection(subTableItem.collection.data)"
        ></xi-icon-button>
      }
      <xi-icon-button
        [tooltip]="{
          text: subTableItem.collection.upload
            ? t('collection-information')
            : t('collection-information-unavailable'),
        }"
        [disabled]="!subTableItem.collection.upload"
        icon="info"
        (onClick)="collectionActions.showUploadInfoDialog(subTableItem.collection)"
      ></xi-icon-button>
      @if (!isReadOnly) {
        <xi-icon-button
          [disabled]="subTableItem.collection.data.locked"
          [tooltip]="{ text: t('rename') }"
          icon="edit"
          (onClick)="collectionActions.onShowRenameCollectionDialog(subTableItem.collection)"
        ></xi-icon-button>
        <xi-icon-button
          [disabled]="disableUploadDocuments(subTableItem.collection.data)"
          [tooltip]="{
            text: disableUploadDocuments(subTableItem.collection.data)
              ? subTableItem.collection.data.locked
                ? t('collection-locked')
                : t('upload-collection-disabled')
              : t('upload-docs'),
          }"
          icon="upload"
          (onClick)="collectionActions.onShowNewCollectionDialog(subTableItem.collection)"
        ></xi-icon-button>
        <xi-default-button
          [text]="t('run-analysis')"
          [disabled]="!subTableItem.collection.canCreateAnalysis"
          (onClick)="collectionActions.showNewAnalysisDialog(subTableItem.collection)"
        ></xi-default-button>
      }
    </div>
  </ng-template>

  <!-- group analysis table top actions -->
</ng-container>

@if (showSpotlightIdeasDialog) {
  <app-lex-xi-modal
    [isVisible]="showSpotlightIdeasDialog"
    maxWidth="960px"
    (close)="onSpotlightIdeasDialogClosed(null)"
  >
    <ng-template appXIModalContent>
      <app-spotlight-dashboard-ideas-dialog
        [data]="spotlightIdeasDialogData"
        [mode]="spotlightIdeasDialogMode"
        (modalClosed)="onSpotlightIdeasDialogClosed($event)"
      ></app-spotlight-dashboard-ideas-dialog>
    </ng-template>
  </app-lex-xi-modal>
}
